import { gql } from "@apollo/client";
import { SaleViewPageQuery } from "types/graphql";
import { useContext } from "react";
import { getAppContext } from 'config/AppContext';
import { useTranslation } from "react-i18next";
import SaleView from "components/entities/agriculture/sale/SaleView";
import { AppRoutes } from "config/router";
import { Roles } from "utilities/app-utilities";
import PageView, { PageViewPropsType } from "components/common/page/PageView";

const salesViewPage = gql`
query saleViewPage($id: Int){
    sale(id:$id) {
      id,
      name,
      date,
      kg,
      pricePerKg,
      total,
      person {
          id,
          name,
          countryCode
          country {
            alpha3Code
            name
            flag
          }
      },
      wallet {
          id,
          name,
          balance,
          archived
      },
      category {
          id,
          name
      },
      cartQuantity,
      incomeId,
      chamber,
      note,
      type,
      fruit {
        name,
        id
      },
      season {
        id,
        name
      }
    }
  }
`;

const SaleViewPage = () => {
    const context = getAppContext(useContext);
    const [t] = useTranslation();

    const config: PageViewPropsType<SaleViewPageQuery> = {
        name:"sale-view-page-view",
        title:t('pages.agriculture.sale.view'),
        query: salesViewPage,
        queryDataPropertyName: "sale",
        editUrl: context.userHasRole(Roles.AGRICULTURE_SALES_WRITE) ? AppRoutes.AGRICULTURE_SALE_EDIT : undefined,
        onDelete: context.userHasRole(Roles.AGRICULTURE_SALES_WRITE) ? 'saleDelete' : undefined,
        view: i => <SaleView model={i!.sale!} view="default" name="sale-view-page-view" />,
    }

    return (
        <PageView {...config}/>
    );
};

export default SaleViewPage;
